import { Dot } from "../data/models/Dot.js";

export function isPrimaryPointer(context) {
  return context.event?.button === undefined || context.event.button === 0;
}

export function createStyledDot(context, point, prefix = "dot") {
  const toolOptions = getToolOptions(context.config);

  return context.dataManager.addDot(
    new Dot({
      id: context.dataManager.createUniqueDotId(prefix),
      x: point.x,
      y: point.y,
      meta: {
        radius: toolOptions.dotRadius,
        color: toolOptions.strokeColor
      }
    })
  );
}

export function createDotData(context, point, id = "preview-dot") {
  const toolOptions = getToolOptions(context.config);

  return {
    id,
    x: point.x,
    y: point.y,
    meta: {
      radius: toolOptions.dotRadius,
      color: toolOptions.strokeColor
    }
  };
}

export function resolveOrCreatePoint(context, point = context.worldPoint) {
  const existingDot = findNearestDot({
    documentModel: context.getDocument(),
    screenPoint: context.screenPoint,
    worldToScreen: context.worldToScreen,
    tolerance: context.config.tools.pointHitTolerance
  });

  return existingDot ?? createStyledDot(context, point);
}

export function findNearestDot({ documentModel, screenPoint, worldToScreen, tolerance = 8 }) {
  let nearestDot = null;

  for (const dot of documentModel.dots) {
    const dotScreenPoint = worldToScreen(dot);
    const distance = Math.hypot(screenPoint.x - dotScreenPoint.x, screenPoint.y - dotScreenPoint.y);

    if (distance > tolerance) {
      continue;
    }

    if (nearestDot && distance >= nearestDot.distance) {
      continue;
    }

    nearestDot = { dot, distance };
  }

  return nearestDot?.dot ?? null;
}

export function getToolOptions(config) {
  return {
    strokeColor: config.toolOptions?.strokeColor ?? config.styles?.stroke ?? "#111111",
    fillColor: config.toolOptions?.fillColor ?? config.styles?.fill ?? "transparent",
    lineWidth: config.toolOptions?.lineWidth ?? config.styles?.lineWidth ?? 2,
    dotRadius: config.toolOptions?.dotRadius ?? config.styles?.dotRadius ?? 4,
    rectangleFilled: config.toolOptions?.rectangleFilled ?? false
  };
}
